// extracted by mini-css-extract-plugin
export default {"Approach":"Approach_Approach__D7vJn","whyusHead":"Approach_whyusHead__mlioR"};